import { filterMultiPack, getStringAfterSplit } from '@tcp/core/src/utils/utils';

export function fetchProductId(partId) {
  let multipleProduct = false;
  let newPartId;
  let multiplePartId = '';
  if (partId.includes(',')) {
    multipleProduct = true;
    const arrayOfPartNum = getStringAfterSplit(partId, ',');
    for (let i = 0; i < arrayOfPartNum.length; i += 1) {
      multiplePartId = multiplePartId.concat(getStringAfterSplit(arrayOfPartNum[i], '#')[0]);
      if (i !== arrayOfPartNum.length - 1) {
        multiplePartId = multiplePartId.concat(',');
      }
    }
  } else {
    newPartId = !!partId && [getStringAfterSplit(partId, '#')];
  }
  return multipleProduct ? multiplePartId : newPartId[0][0];
}

export const getMultipackProduct = (newfetchDetailArray) => {
  const filterData =
    newfetchDetailArray &&
    newfetchDetailArray.product &&
    newfetchDetailArray.product.categoryIdList;
  return filterData && filterMultiPack(filterData);
};

export const storeBossBopisEligibility = (stores, isBopisCtaEnabled, isBossCtaEnabled) => {
  const bossBopisEnabled =
    stores?.filter((store) => {
      return (
        store.storeBossInfo &&
        store.storeBossInfo.isBossEligible === '1' &&
        (store.pickupType.isStoreBossSelected || store.pickupType.isStoreBopisSelected)
      );
    }).length > 0;

  return bossBopisEnabled && (isBopisCtaEnabled || isBossCtaEnabled);
};

export const getCurrentProductId = (currentProduct) => {
  return (
    currentProduct &&
    currentProduct.generalProductId &&
    currentProduct.generalProductId.split('_')[0]
  );
};
